import Vue from 'vue'
import Tournament from '../models/tournament'
import Team from '../models/team'

import ApiBase from '@/api/apiBase'
import moment from 'moment'

class ApiTournaments {

    static find(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}`, callBack, ApiTournaments.parseFind, errorCallBack)
    }

    static all(callback, errorCallBack){
        ApiBase.get(`/tournaments`, callback, ApiTournaments.parseAll, errorCallBack)
    }


    static parseFind(response){
        return Tournament.parse(response.data.data)
    }

    static parseAll(response){
        let result = []
        for(var i in response.data.data){
            result.push(Tournament.parse(response.data.data[i]))
        }
        return result
    }

    static create(tournament, callback, errorCallback) {

        let data = {
            name: tournament.name,
            registries: tournament.registries,
            team_approval:tournament.team_approval,
            start_date: tournament.startDate,
            end_date: tournament.endDate,
            price: Number(tournament.price),
            currency: tournament.currency,
            number_of_sets: Number(tournament.numberOfSets),
            periodicity: Number(tournament.periodicity),
            gol: Boolean(tournament.gol),
            penalties: Boolean(tournament.penalties),
            points_per_match_won: Number(tournament.pointsPerMatchWon),
            points_per_match_draw: Number(tournament.pointsPerMatchDraw),
            match_suspensions_per_red: Number(tournament.matchSuspensionsPerRed),
            match_suspensions_per_double_yellow: Number(tournament.matchSuspensionsPerDoubleYellow),
            team_type: tournament.team_type,
            player_validation: tournament.player_validation,
            mode: tournament.mode,
            status: "paused"
        }



        ApiBase.post(`/tournaments`, data, callback, ApiBase.noParse, errorCallback)
    }

    static finalize(tournamentID, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${tournamentID}/finalize`, callBack, ApiBase.noParse, errorCallBack)
    }

    static update(tournament, callback, errorCallback) {
      console.log("TOURNAMENT",tournament)
        let data = {
            id: tournament.id,
            name: tournament.name,
            start_date: tournament.startDate,
            end_date: tournament.endDate,
            price: tournament.price,
            team_approval:tournament.team_approval,
            currency: tournament.currency,
            numberOfSets: tournament.numberOfSets,
            periodicity: tournament.periodicity,
            gol: tournament.gol,
            penalties: tournament.penalties,
            points_per_match_won: Number(tournament.pointsPerMatchWon),
            points_per_match_draw: Number(tournament.pointsPerMatchDraw),
            match_suspensions_per_red: tournament.matchSuspensionsPerRed,
            match_suspensions_per_double_yellow: tournament.matchSuspensionsPerDoubleYellow,
            team_type: tournament.team_type,
            player_validation: tournament.player_validation,
            status: tournament.status,
            mode: tournament.mode
        }
        console.log("Data",data)

        ApiBase.put(`/tournaments/${tournament.id}`, data, callback, ApiBase.noParse, errorCallback)
    }

    /*CALENDAR*/
    static updateCalendar(tournament,callback,errorCallBack){
      console.log("updateCalendarA",tournament)
      var sets = tournament.sets
      var data = {sets:[],notify:tournament.notify}
      for(var i = 0; i < sets.length ; i++){
        let set = ApiTournaments.getSetData(sets[i])
        //if(set.matches.length>0 || !set.id){
          data.sets.push(set)
        //}
        }
        console.log("updateCalendarB",JSON.stringify(data))
        ApiBase.put(`/tournaments/${tournament.id}`, data, callback, ApiBase.noParse, errorCallBack)
      }




    static getSetData(set){
      var result = {matches:[]}
      if(set.id){
        result.id = set.id
      }else{
        result.type = set.type
        if(set.type != "regular"){
          result.start_date = set.start_date
        }
      }
      for (var i = 0; i < set.matches.length; i++) {
        let match = ApiTournaments.getMatchData(set.matches[i])
        result.matches.push(match)
      }
      return result
    }
    static getMatchData(match){
     var result = {}
     result.duration = Number(match.duration)
     if(match.team_a_alias && match.team_a_alias.length > 0){
       result.team_a_alias = match.team_a_alias
     }

     if(match.team_b_alias && match.team_b_alias.length > 0){
       result.team_b_alias = match.team_b_alias
     }

     result.court_id = match.court ? match.court.id : null
     result.date = match.date ? moment(match.date).format('YYYY-MM-DDTHH:mmZ') : null
     result.team_a_id = match.teamA ? match.teamA.id : null
     result.team_b_id = match.teamB ? match.teamB.id : null
     if(match.id && match.id >= 0 ){
       result.id = match.id
     }

     return result

    }

    /*FIN CALENDAR*/

    static updateArbitraryPoints(tournamentId,teamId,finalPoints,callback,errorCallBack){
      var teams = {
        [teamId] : {
          final_points : finalPoints
        }
      }
      let data = {
        teams:teams
      }
        ApiBase.put(`/tournaments/${tournamentId}/statistics/general_table`, data, callback, ApiBase.noParse, errorCallBack)
    }

    static results(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/results`, callBack, ApiTournaments.parseResults, errorCallBack)
    }

    static parseResults(response){
        let result = []
        console.log("RESULTS",response.data)
        /*for(var i in response.data.data){
            result.push(Tournament.parse(response.data.data[i]))
        }*/
        return response.data.data
    }

    static goals(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/goals`, callBack, ApiBase.noParse, errorCallBack)
    }

    static generalTable(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/statistics/general_table`, callBack, ApiBase.noParse, errorCallBack)
    }

    static groupedGeneralTable(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/statistics/general_table_grouped_by_groups`, callBack, ApiBase.noParse, errorCallBack)
    }

    static yellowCards(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/yellow_cards`, callBack, ApiBase.noParse, errorCallBack)
    }

    static redCards(id, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${id}/red_cards`, callBack, ApiBase.noParse, errorCallBack)
    }

    static playersOfTeam(tournamentid, teamid, callBack, errorCallBack) {
        ApiBase.get(`/tournaments/${tournamentid}/teams/${teamid}/players`, callBack, ApiBase.noParse, errorCallBack)
    }

    static resetArbitraryPoints(tournamentId, teamId, callBack, errorCallBack) {
      ApiBase.post(`/tournaments/${tournamentId}/statistics/general_table/${teamId}/reset_arbitrary_points`, null, callBack, ApiBase.noParse, errorCallBack)
    }

    static captureResult(match,callBack, errorCallBack){
      /*gol, opponent_gol, players :[ "player_id", "gol", "red_cards", "yellow_cards", "real_going" 0 no fue, 1 fue, 2 no se sabe//Dato capturado por cualquiera sobre si otro jugador realmente fue "gol", ]*/
      var players = match.result.team_a_players.concat(match.result.team_b_players)
      for(var i in players){
        let player = players[i]
        players[i] = {
          player_id: player.player_id,
          gol: player.gol,
          red_cards: player.red_cards,
          yellow_cards: player.yellow_cards,
          real_going: player.real_going ? 1 : 0
        }
      }

      var data = {
        gol : match.result.team_a_gol,
        opponent_gol : match.result.team_b_gol,
        players:players
      }
      if(match.result.winner_team){
        data.winner_team = match.result.winner_team
      }
      ApiBase.post(`/matches/${match.id}/capture_results`,data, callBack, ApiBase.noParse, errorCallBack)
    }

    static resetResults(match, callBack, errorCallBack) {
      ApiBase.post(`/matches/${match.id}/reset_results`, null , callBack, ApiBase.noParse, errorCallBack)
    }

    static pause(tournament, callback, errorCallback) {
        let data = {
            status: tournament.status == "active" ? "paused" : "active"
        }

        ApiBase.put(`/tournaments/${tournament.id}`, data, callback, ApiBase.noParse, errorCallback)
    }

    static registrations(tournamentId, callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/petitions`, callback, ApiBase.noParse, errorCallback)
    }

    static createRegistration(data,callback, errorCallback){
      let tournamentId = data.tournamentId
      ApiBase.post(`/tournaments/${tournamentId}/pre_registry`,data,callback, ApiBase.noParse, errorCallback)
    }

    static tournamentBasicInfo(tournamentId, callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/basic_info`, callback, ApiBase.noParse, errorCallback)
    }

    static resolveRegistrations(tournamentId,registrationId,accepted,ammount,callback, errorCallback){
      var data = {accepted:accepted}
      if(ammount){
        data.amount = Number(ammount)
      }
      ApiBase.post(`/tournaments/${tournamentId}/petitions/${registrationId}/resolve`,data,callback, ApiBase.noParse, errorCallback)
    }

    static acceptAndMarkAsPaidARegistration(tournamentId,registrationId,ammount,callback, errorCallback){
      var data = {}
      if(ammount){
        data.amount = Number(ammount)
      }
      ApiBase.post(`/tournaments/${tournamentId}/petitions/${registrationId}/accept_and_mark_as_paid`,data,callback, ApiBase.noParse, errorCallback)
    }

    static archiveRegistration(tournamentId,registrationId,callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/petitions/${registrationId}/archive`,callback, ApiBase.noParse, errorCallback)
    }

    static requests(tournamentId, callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/list_teams_pendings_to_ingress`, callback, ApiBase.noParse, errorCallback)
    }
    //POST api_admin/tournaments/{tournament}/petitions/{petition}/resolve

    static accessPetitions(tournamentId, callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/access_petitions`, callback, ApiBase.noParse, errorCallback)
    }

    static resolveAccesPetition(tournamentId,petitionId,accepted,callback, errorCallback){
      let data = {accepted:accepted}
      ApiBase.post(`/tournaments/${tournamentId}/access_petitions/${petitionId}/resolve`,data,callback, ApiBase.noParse, errorCallback)
    }
    static resolvePlayerOfficialInfo(tournamentId,playerId,status,callback, errorCallback){
      let data = {status:status}
      ApiBase.post(`/tournaments/${tournamentId}/official-info/${playerId}/resolve`,data,callback, ApiBase.noParse, errorCallback)
    }

    static downloadAcceptPlayersPdf(tournamentId,teamId,callback, errorCallback){
      ApiBase.getFile(`/tournaments/${tournamentId}/linked-team/${teamId}/accepted-players-pdf`, callback, ApiBase.noParse, errorCallback)
    }

    static teams(tournamentId,callback, errorCallback){
      ApiBase.get(`/tournaments/${tournamentId}/teams`, callback, ApiTournaments.parseTeams, errorCallback)
    }

    static createGroup(tournamentId,groupName,callback, errorCallback){
      let data = {
        name:groupName
      }
      ApiBase.post(`/tournaments/${tournamentId}/groups`,data,callback, ApiBase.noParse, errorCallback)
    }

    static editGroup(tournamentId,groupId,groupName,callback, errorCallback){
      let data = {
        name:groupName
      }
      ApiBase.put(`/tournaments/${tournamentId}/groups/${groupId}`,data,callback, ApiBase.noParse, errorCallback)
    }

    static removeGroup(tournamentId,groupId,callback, errorCallback){

      ApiBase.get(`/tournaments/${tournamentId}/groups/${groupId}/remove`,callback, ApiBase.noParse, errorCallback)
    }

    static editTeamGroup(tournamentId,groupId,teamId,callback, errorCallback){
      let data = {
        tournament_group_id:groupId
      }
      ApiBase.put(`/tournaments/${tournamentId}/teams/${teamId}/update_group`,data,callback, ApiBase.noParse, errorCallback)
    }

    static parseTeams(response){
      for(var i in response.data.data.grouped_teams){
        let group = response.data.data.grouped_teams[i]
        for(var t in group.teams){
          group.teams[t] = Team.parse(group.teams[t])
        }
      }
      for(var i in response.data.data.other_teams){
        response.data.data.other_teams[i] = Team.parse(response.data.data.other_teams[i])
      }
      return response
    }

}

export default ApiTournaments



// WEBPACK FOOTER //
// ./src/api/apiTournaments.js